let pre, type, post;

const list_pre = {
    en: ["Secret", "Mysterious", "Windy", "Observant", "Green", "Blue", "Red", "Big", "Small", "Miniature", "Huge", "Orange", "Smiling", "Frowning ", "Yellow", "Rich", "Curly", "Invisible", "Royal", "Mighty", "Prickly", "Pink", "Thundering", "Explosive", "Sandy", "Musical", "Hidden"],
    bg: ["Таен", "Секретен", "Мистериозен", "Завеян", "Наблюдателен", "Зелен", "Син", "Червен", "Голям", "Малък", "Миниатюрен", "Огромен", "Оранжев", "Усмихнат", "Намръщен", "Жълт", "Планински", "Богат", "Къдрав", "Невидим", "Кралски", "Могъщ", "Бодлив", "Розов", "Гърмящ"]
}

const list_type = {
    en: ["lemur", "tiger", "owl", "lizard", "rabbit", "wolf", "stone", "elixir", "alchemist", "scientist", "meerkat", "jar", "padlock", "cyclops", "phantom", "banana", "tomato", "carrot", "onion", "robber", "ghost", "hedgehog", "jinn", "coconut", 'teapot', 'creeper', 'chest', 'calculator'],
    bg: ["лемур", "тигър", "бухал", "гущер", "заек", "вълк", "камък", "еликсир", "алхимик", "учен", "сурикат", "буркан", "катинар", "циклоп", "фантом", "банан", "домат", "морков", "лук", "обирджия", "призрак", "таралеж", "джин", "кокосов орех", "чайник", 'крийпър', 'сандък', 'калкулатор']
}
const list_post = {
    en: ["with a hat", "with a bow tie", "with a magnifying glass", "with an umbrella", "with a monocle", "with a briefcase", "with a banana peel", "with a backpack", "with a flower", "with a pumpkin lantern", "in a cave", "with a torch", "with a pickaxe", "with a whisk", "with a clover", "in a bottle", "with a crown", "with a magic wand", "with three wishes", "with an ice cube", "with wings", "with a cookbook", "with a brush", "with a map", "with a test tube", "with a book"],
    bg: ["с шапка", "с папионка", "с лупа", "с чадър", "с монокъл", "с куфарче", "с бананова обелка", "с раничка", "с цвете", "с тиквен фенер", 'в пещера', "с факла", "с кирка", "с метличка", "с детелина", "в бутилка", "с корона", "с магическа пръчка", "с три желания", "с ледено кубче", "с криле", "с коктейлно чадърче", "в шарен дъждобран", "зад елха", "в къщичка за птици", "с готварска книга", "с четка", "с карта", "с епруветка", "с книга"]

}


export async function createName(lang) {
    if (lang == 'bg') {
        pre = list_pre.bg;
        type = list_type.bg;
        post = list_post.bg;
    } else {
        pre = list_pre.en;
        type = list_type.en;
        post = list_post.en;
    }
    let name = pre[getRandomInt(0, pre.length - 1)] + " " + type[getRandomInt(0, type.length - 1)] + " " + post[getRandomInt(0, post.length - 1)];
    return name;
}

function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}